export function getHeading(text, list) {
  return `${text} (${list.length})`
}
